import Vue from "vue"
import vuetify from "./plugins/vuetify"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import Toasted from "vue-toasted"

// tslint:disable-next-line:no-var-requires
const cKEditor = require("@ckeditor/ckeditor5-vue")

import DefaultLayout from "./layouts/DefaultLayout.vue"
import LoginLayout from "./layouts/LoginLayout.vue"
import VueHead from "vue-head"

Vue.component("default-layout", DefaultLayout)
Vue.component("login-layout", LoginLayout)

Vue.config.productionTip = false
Vue.use(cKEditor)
Vue.use(Toasted, {
  duration: 2000,
  fullWidth: true,
  keepOnHover: true,
})
Vue.use(VueHead)

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app")
